























































import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';
import D008 from '@/presentations/company_slides/D008.vue';
import D008GT from '@/presentations/company_slides/D008GT.vue';
import D009 from '@/presentations/company_slides/D009.vue';
import D009GT from '@/presentations/company_slides/D009GT.vue';
import ProfitLoss from '@/charts/ProfitLoss.vue';
import CashflowYears from '@/charts/CashflowYears.vue';
import Cashflow from '@/charts/CashFlow.vue';
import D006 from '@/presentations/company_slides/D006.vue';
import Balance from '@/charts/BalanceGT.vue';
import D005 from '@/presentations/company_slides/D005.vue';
import Compass from '@/components/Compass.vue';
import CashflowTable from '@/components/CashflowTable.vue';
import CashflowDaytoday from '@/components/CashflowDaytoday.vue';
import D001 from '@/presentations/competitors_slides/D001.vue';
import D002 from '@/presentations/competitors_slides/D002.vue';
import D003 from '@/presentations/competitors_slides/D003.vue';
import D004 from '@/presentations/competitors_slides/D004.vue';
import BalanceBarCashYears from '@/charts/BalanceBarCashYears.vue';
import SustainabilityImpact from '@/components/gt/SustainabilityImpact.vue';
import SustainabilityQuestions from '@/components/gt/SustainabilityQuestions.vue';
import SustainabilityProcess from '@/components/gt/SustainabilityProcess.vue';

@Component({components: {
    SustainabilityProcess,
    SustainabilityQuestions,
    SustainabilityImpact,
    BalanceBarCashYears,
    D004,
    D003,
    D002,
    D001,
    CashflowDaytoday,
    CashflowTable, D008, D008GT, D009, D009GT, ProfitLoss, D006, Balance, D005, Compass, CashflowYears, Cashflow}})
export default class Chart extends Slide {
  get title() {
    switch (this.section.SubType) {
      case 'profitloss': return 'Resultat';
      case 'profitlossBarTurnoverYears': return 'Resultat';
      case 'profitlossdiagram': return 'Resultatdiagram';
      case 'profitlossWaterfallLatest': return 'Resultatdiagram';
      case 'profitlossyears': return 'Flerår';
      case 'profitlossBarYears': return 'Flerår';
      case 'balanceBarCashYears': return 'Kassa & Bank';
      case 'balance': return 'Balans';
      case 'balanceBarSolidityYears': return 'Balans';
      case 'balancediagram': return 'Balansdiagram';
      case 'balanceWaterfallLatest': return 'Balansdiagram';
      case 'balanceyears': return 'Flerår';
      case 'balanceBarYears': return 'Flerår';
      case 'compass': return 'Senaste året';
      case 'compassyears': return 'Flerår';
      case 'cashflowyears':
      case 'cashflowBarYears':
        return 'Historik';
      case 'cashflow':
      case 'cashflowWaterfallLatest':
        return 'Kassaflöden';
      case 'cashflowdaytoday':
      case 'cashflowDoughnutLatest':
        return 'Operativa kassaflöden';
      case 'competitionBarTurnoverYears': return 'Nettoomsättning, flerår';
      case 'competitionBarProfitlossLatest': return 'Resultatdiagram, senaste';
      case 'competitionBarBalanceYears': return 'Balansomslutning, flerår';
      case 'competitionBarBalanceLatest': return 'Balansdiagram, senaste';
      case 'sustainabilityImpact': return 'Förutsättningar';
      case 'sustainabilityQuestions': return 'Frågor';
      case 'sustainabilityProcess': return 'Process';
      case 'profitlossGT': return 'Nettoomsättning  Rörelsemarginal';
      case 'balanceGT': return 'Balansomslutning Soliditet';
    }
    return '';
  }

  // get split() {
  //   switch (this.section.SubType) {
  //     case 'sustainabilityImpact':
  //     case 'sustainabilityQuestions':
  //     case 'sustainabilityProcess':
  //       return false;
  //   }
  //   return true;
  // }
}
